import { render } from "./warehouse-detail.vue?vue&type=template&id=1e41319c"
import script from "./warehouse-detail.vue?vue&type=script&lang=js"
export * from "./warehouse-detail.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__